import styled from 'styled-components';

export const AboutWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row;
  pointer-events: all;

  #MainAbout {
    flex: 1;
    min-width: 800px;
    height: 100%;
    position: relative;
    overflow: hidden;
    display: -webkit-flexbox;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    justify-content: center;
    background-color: #000000aa;  
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);

    #AboutBox {
      width: 50%;
      min-width: 450px;
      height: 50%;
      min-height: 450px;
      background-color: #333333;
      border-radius: 25px;
      padding: 20px;
      display: -webkit-flexbox;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-flex-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      justify-content: center;
      flex-flow: column;

      > span {
        font-size: 12px;
        padding: 20px;
        margin: 0px;
        text-align: center;
      }
    }

    #TitleShower {
      width: 100%;
      max-width: 780px;
      height: 216px;
      pointer-events: none;
    }
  }

  #LicensesPane {
    width: 400px;
    height: 100%;
  }
`;

export default AboutWrapper;